import { useEffect, useState } from "react";
import { API } from "./api";
import { Card, CardContent, Typography, Grid, Button } from "@mui/material";
import Dashboard from "./Dashboard";

export default function Applications() {
  const [apps, setApps] = useState([]);
  const [selectedApp, setSelectedApp] = useState(null);
  const [selectedEnv, setSelectedEnv] = useState(null);

  // 🔥 FETCH ALL APPS
  useEffect(() => {
    API.get("/apps")
      .then((res) => {
        const data = res.data.data || res.data || [];
        setApps(data);
      })
      .catch((err) => {
        console.error("API ERROR:", err);
      });
  }, []);

  // 🎯 STEP 1 → APP CARDS (WITH COUNT)
  if (!selectedApp) {
    const appMap = {};

    apps.forEach((a) => {
      if (!a.app_name) return;
      if (!appMap[a.app_name]) appMap[a.app_name] = 0;
      appMap[a.app_name]++;
    });

    const uniqueApps = Object.keys(appMap);

    return (
      <Grid container spacing={3}>
        {uniqueApps.map((app) => (
          <Grid item xs={2} key={app}>
            <Card
              onClick={() => setSelectedApp(app)}
              style={{
                cursor: "pointer",
                background: "linear-gradient(135deg, #3b82f6, #1e293b)",
                color: "white",
                borderRadius: 12,
                textAlign: "center",
              }}
            >
              <CardContent>
                <Typography variant="h6">{app}</Typography>
                <Typography variant="body2">
                  {appMap[app]} apps
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }

  // 🎯 STEP 2 → ENV CARDS (FILTERED + COUNT)
  if (!selectedEnv) {
    const envMap = {};

    apps
      .filter((a) => a.app_name === selectedApp)
      .forEach((a) => {
        if (!a.environment) return;
        if (!envMap[a.environment]) envMap[a.environment] = 0;
        envMap[a.environment]++;
      });

    const envs = Object.keys(envMap);

    return (
      <div>
        <Button onClick={() => setSelectedApp(null)} style={{ marginBottom: 10 }}>
          ⬅ Back
        </Button>

        <Grid container spacing={3}>
          {envs.map((env) => (
            <Grid item xs={2} key={env}>
              <Card
                onClick={() => setSelectedEnv(env)}
                style={{
                  cursor: "pointer",
                  background: "linear-gradient(135deg, #10b981, #1e293b)",
                  color: "white",
                  borderRadius: 12,
                  textAlign: "center",
                }}
              >
                <CardContent>
                  <Typography variant="h6">{env}</Typography>
                  <Typography variant="body2">
                    {envMap[env]} apps
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </div>
    );
  }

  // 🎯 STEP 3 → FILTERED TABLE
  return (
    <Dashboard
      filterApp={selectedApp}
      filterEnv={selectedEnv}
    />
  );
}